var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEmptyChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 159,
    viewBox: "0 0 160 159",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14.5,
    y: 23,
    width: 131,
    height: 96,
    rx: 11,
    fill: "#278176",
    fillOpacity: 0.2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 44.5,
    y: 129,
    width: 71,
    height: 7,
    rx: 3.5,
    fill: "#278176",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.5 60L52.5 99L42.5 99L42.5 60L52.5 60Z",
    fill: "#278176",
    fillOpacity: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.5 45L69.5 99L59.5 99L59.5 45L69.5 45Z",
    fill: "#278176",
    fillOpacity: 0.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.5 65L86.5 99L76.5 99L76.5 65L86.5 65Z",
    fill: "#278176",
    fillOpacity: 0.4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.5 38L103.5 99L93.5 99L93.5 38L103.5 38Z",
    fill: "#278176",
    fillOpacity: 0.4
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.5 96.0625L120.5 99L110.5 99L110.5 96.0625L120.5 96.0625ZM120.5 84.3125L120.5 90.1875L110.5 90.1875L110.5 84.3125L120.5 84.3125ZM120.5 72.5625L120.5 78.4375L110.5 78.4375L110.5 72.5625L120.5 72.5625ZM120.5 60.8125L120.5 66.6875L110.5 66.6875L110.5 60.8125L120.5 60.8125ZM120.5 52L120.5 54.9375L110.5 54.9375L110.5 52L120.5 52Z",
    fill: "#278176",
    fillOpacity: 0.4
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.5 103H33.5V99H127.5V103Z",
    fill: "#278176",
    fillOpacity: 0.4
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyChart);
export default __webpack_public_path__ + "static/media/empty_chart.1f81b15056c6bfe309e0244c88974a81.svg";
export { ForwardRef as ReactComponent };